import { useId, type InputHTMLAttributes } from 'react';

interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  error?: string;
}

export function TextField({ label, error, className, ...rest }: TextFieldProps) {
  const id = useId();
  return (
    <div className="ne-field">
      <label className="ne-field__label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className={['ne-input', error ? 'ne-input--error' : '', className]
          .filter(Boolean)
          .join(' ')}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        {...rest}
      />
      {error ? (
        <span id={`${id}-error`} className="ne-field__error" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}
